module.exports = __webpack_public_path__ + "media/packs/images/partners/happy-paw-0b1688e4e68734f2e2c59142749f6037.jpg";